import React, { useMemo, useState } from "react";
import { useContextProvider } from "../../context";
import { Language } from "../../types";
import "./index.css";
import { useLocation, useNavigate } from "react-router-dom";
import backSvg from "./back.svg";

const dict = {
  [Language.English]: {
    home: "Home",
    [Language.English]: "English",
    [Language.Spanish]: "Spanish",
    [Language.Ukrainian]: "Ukrainian",
    [Language.Russian]: "Russian",
    icon: "🇬🇧",
  },
  [Language.Spanish]: {
    home: "Inicio",
    [Language.English]: "Inglés",
    [Language.Spanish]: "Español",
    [Language.Ukrainian]: "Ucraniano",
    [Language.Russian]: "Ruso",
    icon: "🇪🇸",
  },
  [Language.Russian]: {
    home: "Главная",
    [Language.English]: "Английский",
    [Language.Spanish]: "Испанский",
    [Language.Ukrainian]: "Украинский",
    [Language.Russian]: "Русский",
    icon: "🇷🇺",
  },
  [Language.Ukrainian]: {
    home: "Головна",
    [Language.English]: "Англійська",
    [Language.Spanish]: "Іспанська",
    [Language.Ukrainian]: "Українська",
    [Language.Russian]: "Російська",
    icon: "🇺🇦",
  },
};

const supportedLanguages = [
  Language.English,
  Language.Spanish,
  Language.Ukrainian,
  Language.Russian,
];

export const Menu: React.FC = () => {
  const { setLanguage, language } = useContextProvider();
  const [langMenuOpen, setLangMenuOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getIsSelectedClass = (value: Language) => {
    return language === value ? " selected" : "";
  };

  const handleLangClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!langMenuOpen) {
      setLangMenuOpen(true);

      return;
    }
    const language = e.currentTarget.dataset.language as Language;
    setLanguage(language);
    setLangMenuOpen(false);
  };

  const languages = [
    language,
    ...supportedLanguages.filter((l) => l !== language),
  ];

  const isGoBackVisible = useMemo(() => {
    return location.pathname !== "/";
  }, [location.pathname]);

  const logoClickHandler = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="Menu">
      <div className="Menu-goBackContainer">
        {isGoBackVisible && (
          <button className="Menu-goBackButton" onClick={() => navigate(-1)}>
            <img src={backSvg} alt="Go back button" />
          </button>
        )}
      </div>
      <button
        className="Menu-logo"
        aria-label={dict[language].home}
        title={dict[language].home}
        onClick={logoClickHandler}
      >
        R
      </button>
      <div className="Menu-title">car-rent.vip</div>
      <div className={`Menu-languages${langMenuOpen ? "" : " closed"}`}>
        {languages.map((currentLanguage) => (
          <button
            key={currentLanguage}
            className={`Menu-language${getIsSelectedClass(currentLanguage)}`}
            onClick={handleLangClick}
            aria-label={dict[language][currentLanguage]}
            title={dict[language][currentLanguage]}
            data-language={currentLanguage}
          >
            {dict[currentLanguage].icon}
          </button>
        ))}
      </div>
    </section>
  );
};
